module.exports = __webpack_public_path__ + "static/img/pico413.890da6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico413.png
// module id = OXxU
// module chunks = 0